export const status = [
    { name: 'SELECT STATUS', value: null },
    { name: 'REVIEW', value: 'review' },
    { name: 'RE-SUBMIT', value: 're-submit' },
    { name: 'COMPLETED', value: 'completed' },
]